module.exports = __webpack_public_path__ + "static/media/SoundOn.f203e909.mp3";